<template>
  <div v-viewer class="userpic">
    <img v-if="url" :src="url" alt="" />

    <img v-else src="/redesign/img/userpic.svg" />

    <!-- <svg v-else viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="17" cy="17" r="17" fill="#8E9CBB" />

      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="34" height="34">
        <circle cx="17" cy="17" r="17" fill="#8E9CBB" />
      </mask>

      <g mask="url(#mask0)">
        <path
          d="M28 30L26 31.5V26.5926C26 25.905 25.7103 25.2456 25.1945 24.7594C24.6788 24.2731 23.9793 24 23.25 24H17H10.75C10.0207 24 9.32118 24.2731 8.80546 24.7594C8.28973 25.2456 8 25.905 8 26.5926V31.5L6 30V26.6667C6 25.429 6.50044 24.242 7.39124 23.3668C8.28204 22.4917 9.49022 22 10.75 22C10.75 22 15 22 17 22C19 22 23.25 22 23.25 22C24.5098 22 25.718 22.4917 26.6088 23.3668C27.4996 24.242 28 25.429 28 26.6667V30Z"
          fill="#333333"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23 14C23 17.3137 20.3137 20 17 20C13.6863 20 11 17.3137 11 14C11 10.6863 13.6863 8 17 8C20.3137 8 23 10.6863 23 14ZM21 14C21 16.2091 19.2091 18 17 18C14.7909 18 13 16.2091 13 14C13 11.7909 14.7909 10 17 10C19.2091 10 21 11.7909 21 14Z"
          fill="#333333"
        />
      </g>
    </svg> -->
  </div>
</template>

<script>
export default {
  props: ["url"],
};
</script>

<style lang="scss" scoped>
.userpic {
  width: 34px;
  height: 34px;
  position: relative;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
